/* eslint-disable jsdoc/check-param-names */
import { ActionBrick, registerBrick, Config, Auth, ErrorFlow, BrickContext } from 'olympe';
import { XMLParser } from 'fast-xml-parser';
import { JSONPath } from 'jsonpath-plus';
import { getLogger } from '@olympeio/core';

export default class GetSAMLDetails extends ActionBrick {
    /**
     * Parse the SAML token stored in the indexed DB,
     * test if it has the expected format and provider
     * and retrieve the username values
     * @protected
     * @param {BrickContext} context
     * @param {!Array} inputs
     * @param {function(): void} forwardEvent
     * @param {function(string): void} setUserName
     * @param {function(string): void} setFullName
     * @param {function(string): void} setEmail
     * @param {function(ErrorFlow): void} setErrorFlow
     */
    onUpdate(context, inputs, [forwardEvent, setUserName, setFullName, setEmail, setErrorFlow]) {
        const logger = getLogger('GetSAMLDetails');

        let xmlToken, jsonToken, nameId, attributes;
        try {
            xmlToken = decodeURIComponent(escape(window.atob(Auth.getIDPToken())));
            jsonToken = new XMLParser({
                ignoreAttributes: false,
                attributeNamePrefix: '',
            }).parse(xmlToken);

            nameId = JSONPath('$.samlp:Response.Assertion.Subject.NameID', jsonToken)[0];
            attributes = JSONPath('$.samlp:Response.Assertion.AttributeStatement.Attribute', jsonToken)[0];
        } catch (e) {
            logger.error('Error parsing SAML token');
        }

        const getAttributeWithName = (attrName) => {
            let attr = JSONPath(`$[?(@.Name==="${attrName}")]`, attributes);
            attr = attr !== undefined ? attr[0] : undefined;
            return attr !== undefined ? attr.AttributeValue : '';
        };

        // Fix in case we login with another SAML provider
        if (
            !Array.isArray(attributes) ||
            getAttributeWithName('http://schemas.microsoft.com/identity/claims/identityprovider') !==
                Config.getParameter('uiappValues.saml_provider') ||
            nameId === undefined
        ) {
            logger.error('Wrong SAML provider, reject authentication.');
            setErrorFlow(ErrorFlow.create('Wrong SAML provider, reject authentication.', 0));
        } else {
            setUserName(nameId['#text'] || '');
            setFullName(
                getAttributeWithName('http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname') +
                    ' ' +
                    getAttributeWithName('http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname')
            );
            setEmail(getAttributeWithName('http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'));
            forwardEvent();
        }
    }
}

registerBrick('0184d29f798bcccc6188', GetSAMLDetails);
